import React from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import i18n from 'i18next';
import { siteTheme, languagesInfo, siteConfig } from '../variables/config'
import TLink from '../components/TLink.jsx'
import * as actions from '../stores/actionsList';
import { translate, checkTextTranslation, checkTranslation, checkPermission, pathMaker } from '../utils/useful'
import routes from '../variables/routes';
import FixedView from './FixedView';
import Loader from 'react-loader-spinner';
import HttpServices from '../utils/Http.services';
import { addTopic, removeTopic } from '../utils/socket.services';
import Cookies from "universal-cookie";
import { nanoid } from 'nanoid';
import TabBar from './TabBar.jsx';
import store from '../stores/storeConfig.js';
// import MobileTabBar from './MobileTabBar.jsx';
// import FixedViewBtn from './FixedViewBtn.jsx';


class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            MoileMenu: false,
            showFixedView: false,
            inbox: [],
            inboxId: nanoid(),
            inboxColors: {
                create: { pri: 'rgb(0, 201, 167)', sec: 'rgb(0, 205, 116)' },
                update: { pri: 'rgb(0, 160, 201)', sec: 'rgb(0, 116, 205)' },
                remove: { pri: '#FF3B30', sec: '#dd6070' },

            },
            displayMenu: false,
            mobileLogo: '',

            mainApplets: [

                { name: '{{lang}}Dashboard', href: '/', key: 'home', icon: '/images/kheiry/dashboard.png', page: '/' },

            ]
            // SectionName: ''
        }
        // this.inboxBut = React.createRef();
    }



    componentDidMount() {
        // console.log('this.props.settings.language', this.props)
        const cookies = new Cookies();
        let token = cookies.get('admintoken');
        if (token) {
            this.waitForId(10)
        }
        this.setState({ show: true })
        setTimeout(() => {
            this.setState({ showFixedView: true })
        }, 30);

        setInterval(() => {
            //     console.log("_---_")

            //     if(this.inboxBut){
            //         let viewRect = getBoundingClientRect(this.inboxBut)

            //         console.log(viewRect.left)

            //     }

            // this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: "TEST" })

        }, 1000);
    }

    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            this.fetchInbox()
            this.fetchApplets()
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                }
            }, 500);
        }
    }




    fetchApplets = () => {

        HttpServices.request('getMyApplets', {}, (fetchResult, fetchError) => {
            if (fetchError) { return }

            // console.log(fetchResult, fetchError)

            let mainApplets = this.state.mainApplets
            let settings = { name: '{{lang}}settings', href: '/settings', key: 'settings', icon: '/images/kheiry/settings1.png', page: 'settings', commingSoon: false }
            let branches = fetchResult.info ?? []

            for (let index = 0; index < branches.length; index++) {
                let branch = branches[index];
                branch.icon = '/images/kheiry/ihp.png'
                branch.href = '/branch/' + branch._id
                branch.key = branch._id
            }

            mainApplets = [...mainApplets, ...branches]

            let hasPermissionsAccess = checkPermission('settings', null, 'admin')

            if (hasPermissionsAccess) {

                mainApplets.push(settings)

            }

            this.setState({ branches: fetchResult.info, mainApplets })
        })
    }



    componentDidUpdate(prevProps) {

        if (prevProps.user?.loggedin != this.props.user?.loggedin) {
            if (this.props.user?.loggedin) {

                this.fetchInbox()
                // this.fetchBroadcasts()


            } else {
                this.setState({ inbox: [] })
                removeTopic(this.state.inboxId, this.props.user?.info?._id, 'users', null, this.updateInbox)

            }
        }
    }

    fetchInbox() {

        this.setState({ isLoadingInbox: true })

        HttpServices.request('getLogs', { limit: 20, filter: { opened: false }, id: this.props.user.info._id }, (fetchResult, fetchError, fetchStatus) => {
            // console.log('fetchResultinbox', fetchResult)
            // console.log(fetchError)

            addTopic(this.state.inboxId, 'activities', 'admin', null, this.updateInbox)

            this.setState({ isLoadingInbox: false })
            if (fetchError) {
                // this.setState({ pageStatus: fetchStatus })
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}erd', description: fetchError.message })
                return
            }
            this.setState({ inbox: fetchResult.info }, () => {
                this.calcNoficCount()
            })


            // addTopic(this.state.inboxId, this.props.user?.info?._id, 'users', null, this.updateInbox)

        })
    }


    notifSeen = (id) => {
        console.log("notifSeen")
        HttpServices.request('seenInbox', { id }, (fetchResult, fetchError, fetchStatus) => {

            console.log(fetchError)

            console.log(fetchResult)
            if (fetchError) {
                return
            }

            let inbox = this.state.inbox
            inbox.forEach(element => {
                if (element._id == id) {
                    element.opened = true
                }
            });

            this.setState({ inbox }, () => {
                this.calcNoficCount()
            })


        })

    }

    calcNoficCount = () => {
        let count = 0
        let inbox = this.state.inbox
        inbox.forEach(element => {
            if (!element.opened) {
                count++
            }
        });

        if (count == 20) {
            count = "+20"
        }

        this.setState({ notifCount: count })
    }


    updateInbox = (newData) => {

        console.log("updateInbox")

        let inbox = this.state.inbox
        inbox.splice(0, 0, newData)
        this.setState({ inbox }, () => {
            this.calcNoficCount()
        })
        this.props.actions.addNotif({ type: 'notification', title: newData.type, description: newData.message })

    }



    changeLanguage = (key, value) => {
        i18n.changeLanguage(value)
        this.closeBox()
    }

    countCart() {
        let count = 0
        if (this.props.cart) {
            Array.isArray(this.props.cart.items) && this.props.cart.items.forEach(element => {
                count += element.count
            });
        }
        return count
    }


    checkssion(page, reference) {
        if (!page.roles) {
            return true
        }
        if (reference.info) {
            for (let i = 0; i < page.roles.length; i++) {
                const oneRole = page.roles[i];
                if (oneRole.role === reference.info.role) {
                    return true
                }
            }
        }
    }


    toggleLanguagesBox() {
        if (!this.state.showLanguagesBox) {
            document.addEventListener('mousedown', this.closeBox);
            this.setState({ showLanguagesBox: true })
        } else {
            this.closeBox()
        }
    }

    closeBox = (event) => {
        if (!event || (this.language_select_box && !this.language_select_box.contains(event.target))) {
            document.removeEventListener('mousedown', this.closeBox);
            let box = document.querySelectorAll('.language-select-box')
            if (box) {
                box[0].classList.add('fadeout')
            }

            setTimeout(() => {
                this.setState({ showLanguagesBox: false })
            }, 400);
        }
    }


    openInbox = () => {
        if (this.inboxFixedView) {
            this.inboxFixedView.showView()
        }
        // console.log(this.inboxBut)
    }


    setRef = (el, name) => {
        this[name] = el
    }
    hidePlatform = () => {
        this.platformFixedView.hideView()
    }
    showMenu = () => {
        this.setState({ displayMenu: !this.state.displayMenu });

    }
    handleHeaderItems = (prop) => {
        // console.log('propppppp', prop)
        // if (prop.parent == "whthoutParent") {
        //     ('/' + this.props.myHeaders?.header + '/' + prop.key)
        // } else {
        //     this[(`section${prop.key}`)].showView()
        // }
    }
    render() {
        let inboxes = []
        if (Array.isArray(this.props.inboxes.list) && this.props.inboxes.list.length > 0) {

            inboxes = this.props.inboxes.list.filter(el => !el.opened)
        }

        if (this.state.show) {

            return (
                <header
                    className="header w-100"
                    style={{
                        color: siteTheme.themeColors.headerFont,
                        position: this.props.settings?.fixedHeader ? "fixed" : 'sticky',
                        top: 0,
                        left: 0,
                        width: '100%',
                        zIndex: 10,
                        borderBottom: this.props.settings?.headerBackground ? "" : '#e6eaf2 solid 1px'
                    }}
                >

                    <div
                        className="blur-back w-100 position-relative soft-card soft-card-muted"
                        style={{
                            background: 'linear-gradient(90deg, #10453d 0%, #10453d 75%, #146a5d 100%)',
                            color: this.props.settings?.headerTextColor ?? "#f9fafb",
                            boxShadow: '0 18px 45px rgba(16,69,61,0.35)'
                        }}
                    >
                        <div className='flexcb py-2 px-3 ' style={{ justifyItems: "end" }}>
                            <div className=''>
                                <div className='flexc'>
                                    <TLink
                                        className="hover-scale-sm"
                                        to={'/'}
                                        onClick={() => store.dispatch(actions.initHeader(''))}
                                        style={{ width: '100%', height: '100%', textAlign: 'center', justifyContent: 'center' }}
                                    >
                                        <img className="" src={siteTheme.logo} height={80} alt='' />
                                    </TLink>
                                    {/* <p className='text-white mld-3' style={{ whiteSpace: 'nowrap' }}>{checkTranslation(this.state.SectionName)}</p> */}
                                </div>
                            </div>
                            <div className="flexcc">


                                {Array.isArray(this.props.settings?.headerButtons) && (
                                    this.props.settings?.headerButtons.map((prop, index) => {
                                        // console.log("UPDATE")
                                        return (
                                            <div key={index}>
                                                {prop}
                                            </div>
                                        )
                                    })
                                )}
                                {!this.props.settings?.hideProfileButton && !this.props.user?.loggedin && siteConfig.showProfile && (
                                    <div className="mrd-4">
                                        <TLink pathname='/login' className=" text-small cursor-pointer p-0 flexcc" style={{}}><img src="https://image.flaticon.com/icons/svg/2948/2948035.svg" className={(siteTheme.invertLogo || this.props.settings?.headerInvert) ? 'invert' : ''} height="24px" /></TLink>

                                    </div>
                                )}

                                {!this.props.settings?.hideProfileButton && this.props.user?.loggedin && siteConfig.showProfile && (
                                    <div className="mrd-1">
                                        <TLink pathname='/profile' className=" text-small cursor-pointer p-0 flexcc" style={{}}><img src="/images/icons3/user.png" className={(siteTheme.invertLogo || this.props.settings?.headerInvert) ? 'invert' : 'invert'} height="18px" /></TLink>

                                    </div>
                                )}

                                {/* <button onClick={() => this.openInbox()} ref={el => this.inboxBut = el} className="flexcc mld-4 p-0">
                                    <div className="position-relative flexc">
                                        <img className={(siteTheme.invertLogo || this.props.settings?.headerInvert) ? 'invert' : 'invert'} src="/images/icons3/bell.png" height="16px" alt="" />
                                        {(this.state.notifCount > 0) && (
                                            <div className="flexcc position-absolute white" style={{ top: -10, left: 10, backgroundColor: '#FF3B30ee', borderRadius: 30, minWidth: 20, height: 20, fontSize: 14 }}>
                                                <span>{this.state.notifCount}</span>
                                            </div>
                                        )}
                                    </div>
                                </button> */}
                                {/* <TLink to="/document/senttome" ref={el => this.inboxBut = el} className="flexcc mrd-4 mld-2 p-0">
                                    <div className="position-relative flexcc">

                                        <img className={(siteTheme.invertLogo || this.props.settings?.headerInvert) ? 'invert' : 'invert'} src="/images/icons3/envelope.png" height="16px" alt="" />

                                        {(inboxes?.length > 0) ? (
                                            <div className="flexcc position-absolute white" style={{ top: -10, left: inboxes?.length > 100 ? -5 : 10, backgroundColor: '#FF3B30ee', borderRadius: 30, minWidth: 20, height: 20, fontSize: 14 }}>

                                                {inboxes?.length > 99 ? (
                                                    <span className='px-1'>+99</span>
                                                ) : (
                                                    <span className='px-1'>{inboxes?.length}</span>
                                                )}
                                            </div>
                                        ) : <></>}

                                    </div>
                                </TLink> */}

                                <TLink pathname='/' className="flexcc">
                                    <button ref={el => this.inboxBut = el} className="flexcc mld-4 p-0">
                                        <div className="flexcc">
                                            <img src="/images/icons3/home.png" className='invert' height="16px" alt="" />
                                        </div>
                                    </button>
                                </TLink>


                                {this.inboxBut && (
                                    <FixedView zIndex={1} ref={el => this.inboxFixedView = el} nodeRef={this.inboxBut} topOffset={10} bottomOffset={0} xOffset={0} width={150} >
                                        <div className="blur-back ml-0 position-relative flexcc flex-column ml-4 " style={{ color: '#000510', zIndex: 1, boxShadow: '0px 0px 15px #00000010', backgroundColor: '#fff', borderRadius: 10, width: 300 }}>
                                            <div className='position-absolute' style={{ borderRadius: "3px 0 0 0", top: -6, left: this.props.settings.language == 'fa' ? 24 : 239, width: 13, height: 13, background: '#143e74', transform: "rotate(45deg)" }}></div>
                                            <div className="py-2 px-2 w-100" style={{ background: '#143e74', borderRadius: '10px 10px 0px 0px' }}>
                                                <p className="px-2 white" style={{ fontSize: "14px", fontWeight: "400" }}>{translate('Inbox')}</p>
                                            </div>
                                            <div className="py-2 w-100" style={{ maxHeight: 300, overflow: 'auto' }}>


                                                {this.state.isLoadingInbox && (
                                                    <div className="flexcc mt-2 mb-2">
                                                        <Loader
                                                            type={"ThreeDots"}
                                                            color={"#143e74"}
                                                            height={20}
                                                            width={50}
                                                        />
                                                    </div>
                                                )}

                                                {!this.state.isLoadingInbox && this.state.inbox?.length == 0 && (
                                                    <div className="text-center p-2 my-2">
                                                        <p className="text-normal">{translate('Nothing to show')}</p>
                                                    </div>
                                                )}

                                                {!this.state.isLoadingInbox && this.state.inbox?.map((prop, index) => {
                                                    return (
                                                        <TLink to={prop.url ?? ''} key={index}>
                                                            <div className="w-100 px-3 flexc text-start mb-2" onClick={() => this.notifSeen(prop._id)} style={{ opacity: prop.opened ? '0.5' : '1' }} >
                                                                <div className="flexcc" style={{ padding: '4px', height: 30, width: 30, borderRadius: 30, background: 'linear-gradient(' + this.state.inboxColors[prop.type]?.pri + ',' + this.state.inboxColors[prop.type]?.sec + ')' }}>
                                                                    <img className="" src={'/images/notif2.svg'} width="26px" />
                                                                </div>
                                                                <div className="mld-4">
                                                                    <p className="text-small">{checkTranslation(prop.title)}.</p>
                                                                    <p className="text-smaller">{checkTranslation(prop.message)}.</p>
                                                                </div>
                                                            </div>
                                                        </TLink>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </FixedView>
                                )}


                            </div>
                        </div >


                        <FixedView ref={el => this.platformFixedView = el} nodeRef={this.platformCurrent} topOffset={5} zIndex={10} xOffset={0} boxShadow={true} width={150} rightAlign={this.props.settings.language == 'fa' ? true : false}>
                            <div style={{ borderRadius: 10, backgroundColor: 'red', boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }} onClick={() => this.platformFixedView.hideView()}>
                                <TabBar changeFormObject={this.props.changeFormObject} setData={this.props.setData} hidePlatform={this.hidePlatform} branches={this.state.branches} options={this.state.mainApplets} />
                            </div>
                        </FixedView>


                        {/* {console.log(this.props.mainSettings)} */}

                        <div className='flexc py-2 px-3' style={{ background: "rgba(255,255,255, 0.1)" }}>

                            <button className='flexc py-2 px-2 mrd-2' ref={el => this.platformCurrent = el} onClick={() => this.platformFixedView.showView()} style={{ background: "#fff3", borderRadius: 8 }}>
                                <p style={{ color: "white", fontSize: 14 }} className='cursor-pointer' >{checkTranslation(this.props.mainSettings?.title)}</p>
                                <img width={'10px'} className='mld-2' src="/images/icons/down.png" alt="" />
                            </button>

                            {this.props.mainSettings?.sections?.length > 0 && (

                                <div className=' d-flex sc-hidden' style={{ alignItems: "center", overflowX: 'auto' }}>

                                    <button className='flexc py-2 px-2 mrd-2' ref={el => this.sectionNode = el} onClick={() => this.sectionFixedView.showView()} style={{ background: "#fff3", borderRadius: 8 }}>
                                        <p style={{ color: "white", fontSize: 14 }} className='cursor-pointer' >{checkTranslation(this.props.mainSettings?.sectionTitle ?? "{{lang}}دسترسی سریع")}</p>
                                        <img width={'10px'} className='mld-2' src="/images/icons/down.png" alt="" />
                                    </button>


                                    <FixedView ref={el => this.sectionFixedView = el} nodeRef={this.sectionNode} topOffset={5} zIndex={10} xOffset={0} boxShadow={true} width={200} rightAlign={this.props.settings.language == 'fa' ? true : false}>
                                        <div style={{ borderRadius: 10, backgroundColor: 'red', boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }} onClick={() => this.sectionFixedView.hideView()}>
                                            <TabBar changeFormObject={this.props.changeFormObject} setData={this.props.setData} hidePlatform={this.hidePlatform} branches={this.state.branches} options={this.props.mainSettings?.sections} permissionBaseKey={this.props.mainSettings?.permissionBaseKey} applet={this.props.mainSettings?.applet} baseUrl={this.props.mainSettings?.baseUrl} />
                                        </div>
                                    </FixedView>


                                    {/* {this.props.mainSettings?.sections?.map((prop, index) => {
                                        let activePlatform = this.props.myHeaders?.header
                                        if (activePlatform == 'document') {
                                            activePlatform = 'admin'
                                        }
                                        return (
                                            <>
                                                {prop.parent == 'whthoutParent' ? (
                                                    <>
                                                        <TLink to={'/' + this.props.myHeaders?.header + (prop.key == 'dashboard' ? '' : '/' + prop.key)} >
                                                            <div className='mx-3 mx-md-2 d-flex' style={{ alignItems: "center", }}>
                                                                <img width={'25px'} className={prop.img ? `mld-2` : 'invert mld-2'} src={prop.image} alt="" />
                                                                <p key={index} ref={el => this[(`sectionFixed${prop.key}`)] = el} className='mx-2 text-white cursor-pointer fs-md-13' style={{ whiteSpace: "nowrap" }}>{checkTranslation(prop.title)}</p>
                                                            </div >
                                                        </TLink>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className='mx-3 mx-md-2 d-flex' style={{ alignItems: "center", }}>
                                                            <img width={'15px'} className={prop.img ? `mld-2` : 'invert mld-2'} src={prop.img} alt="" />
                                                            <p key={index} ref={el => this[(`sectionFixed${prop.key}`)] = el} onClick={() => this[(`section${prop.key}`)].showView()} className='mx-2 text-white cursor-pointer fs-md-13' style={{ whiteSpace: "nowrap" }}>{checkTranslation(prop.name)}</p>
                                                        </div >
                                                    </>
                                                )}
                                            </>
                                        )
                                        // }
                                    })} */}


                                </div>
                            )}
                        </div>
                    </div >





                    {
                        this.state.showFixedView && (
                            <>
                                {this.props.myHeaders.object.section?.map((prop, index) => {
                                    let activePlatform = this.props.myHeaders?.header
                                    if (activePlatform == 'document') {
                                        activePlatform = 'admin'
                                    }
                                    return (
                                        <>
                                            <div>
                                                <FixedView ref={el => this[(`section${prop.key}`)] = el} nodeRef={this[(`sectionFixed${prop.key}`)]} boxShadow={true} topOffset={140} zIndex={10} xOffset={this.props.settings.language == 'fa' ? 45 : 0} width={300} maxHeight={500} rightAlign={this.props.settings.language == 'fa' ? true : false} >
                                                    <div style={{ borderRadius: 10, backgroundColor: '#fff', padding: '10px', maxHeight: '500px', overflow: 'auto', boxShadow: " rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}>
                                                        {this.props.myHeaders.object.child && this.props.myHeaders.object.child.map((cProp, cIndex) => {
                                                            if (prop.key == cProp.parent && !cProp.hidePage && checkPermission(`${activePlatform}.` + cProp.key)) {
                                                                // console.log('cPropcscscs', cProp.title)

                                                                return (
                                                                    <>
                                                                        <TLink to={'/' + this.props.myHeaders?.header + '/' + cProp.key} >
                                                                            <div className='flexc cursor-pointer bb-gray' onClick={() => this[(`section${prop.key}`)].hideView()}>
                                                                                <img className="py-2 mrd-3" style={{ opacity: "0.8" }} width={'20px'} src={cProp.image} alt="" />
                                                                                <span className="ListItemName fs-md-13" style={{ color: '#222', whiteSpace: 'nowrap' }}>{checkTranslation(cProp.title)}</span>
                                                                            </div>
                                                                        </TLink>
                                                                    </>
                                                                )
                                                            }
                                                        })}
                                                    </div>
                                                </FixedView >
                                            </div>
                                        </>
                                    )
                                })}
                            </>
                        )
                    }


                </header >
            )
        } else {
            return (<div></div>)
        }
    }








}


const mapStateToProps = state => ({ settings: state.settings, cart: state.cart, user: state.user, inboxes: state.inboxes, myHeaders: state.headers })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Header);

// export default Header

